import { render } from "./receiveCard.vue?vue&type=template&id=bd04ee22&scoped=true"
import script from "./receiveCard.vue?vue&type=script&lang=js"
export * from "./receiveCard.vue?vue&type=script&lang=js"

import "./receiveCard.vue?vue&type=style&index=0&id=bd04ee22&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd04ee22"]])

export default __exports__